export { default } from "./PresetIcon";
